{
  "level": "Nivå",
  "academicDegree": "Studie",
  "all": "Alle",
  "readMore": "Les mer",
  "levels": {
    "Bachelor": "Bachelor",
    "Master": "Master",
    "PhD": "PhD",
    "Executive": "Videreutdanning"
  },
  "filter": {
    "header": "Filtrer",
    "toggleButton": "Filter",
    "resetButton": "Nullstill filter",
    "applyButton": "Vis {{count}} treff",
    "closeButton": "Lukk filter"
  }
}
